const orgIdVariable = ":orgId"
export const NEW = "new";
export const SIGN_UP = `/signup`;
export const SIGN_IN = `/signin`;
export const LANDING = `/landing`;
export const ERROR = `/error`;
export const ABOUT = `/about`;
export const ACCOUNT = `/account`;
export const PASSWORD_FORGET = `/pw-forget`;
export const ORGANIZATIONS = `/organizations`;
export const NEW_ORGANIZATION = `/organizations/new`;

export const MANAGE_USERS_ROUTE = `/${orgIdVariable}/manage-users`;
export const MANAGE_USERS = (orgId:string) =>`/${orgId}/manage-users`;

export const JOIN_ROUTE = `/${orgIdVariable}/join/:invitationCode`;
export const JOIN = (orgId:string, invitationCode:string) =>`/${orgId}/join/${invitationCode}`;

export const DATASOURCES_ROUTE = `/${orgIdVariable}/datasources`;
export const DATASOURCES = (orgId:string) =>`/${orgId}/datasources`;
export const NEW_DATASOURCE_ROUTE = `/${orgIdVariable}/datasource/:datasourceId`;
export const NEW_DATASOURCE = (orgId:string, datasourceId:string) => `/${orgId}/datasource/${datasourceId}`;

export const DASHBOARDS_ROUTE = `/${orgIdVariable}/dashboards`;
export const DASHBOARDS = (orgId:string) => `/${orgId}/dashboards`;
export const DASHBOARD_ROUTE = `/${orgIdVariable}/dashboard/:dashboardId`;
export const DASHBOARD = (orgId:string, did: string) => `/${orgId}/dashboard/${did}`;
export const NEW_DASHBOARD_ROUTE = `/${orgIdVariable}/dashboard/new`;
export const NEW_DASHBOARD = (orgId:string) =>  `/${orgId}/dashboard/new`;

export const ALERTS_ROUTE = `/${orgIdVariable}/alerts`;
export const ALERTS = (orgId:string) => `/${orgId}/alerts`;
export const NEW_ALERT_ROUTE = `/${orgIdVariable}/alerts/new`;
export const NEW_ALERT = (orgId:string) =>  `/${orgId}/alerts/new`;


export const ANALYSES_ROUTE = `/${orgIdVariable}/analyses`;
export const ANALYSES = (orgId:string) => `/${orgId}/analyses`;
export const ANALYSIS_ROUTE = `/${orgIdVariable}/analysis/:analysisId`;
export const ANALYSIS = (orgId:string, aid: string) => `/${orgId}/analysis/${aid}`;
export const QUERY = `/${orgIdVariable}/analysis/:analysisId/query/:queryId`;
export const QUERY_BY_ID = (orgId:string, aid: string, qid: string) =>
  `/${orgId}/analysis/${aid}/query/${qid}`;
export const VERSION =
  `/${orgIdVariable}/analysis/:analysisId/query/:queryId/version/:versionId`;
export const VERSION_BY_ID = (orgId:string, aid: string, qid: string, vid: string) =>
  `/${orgId}/analysis/${aid}/query/${qid}/version/${vid}`;
// TODO
export const HOME = DASHBOARDS;


// WEBPACK FOOTER //
// ./src/constants/routes.ts